import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { useMilestoneContext } from "../context/MilestoneContext";
import MilestoneHeaderSection from "./MilestoneHeaderSection";
import { MilestoneList } from "./MilestoneList";
import { milestoneStyles } from "../styles/milestoneStyles";
import { CombinedMilestone } from "../types";
import { MilestoneComponentContentProps } from "../types/milestoneComponent.types";

export const MilestoneComponentContent: React.FC<MilestoneComponentContentProps> = React.memo(({ milestoneName }) => {
     const { combinedMilestoneData, toggleAccordion, expandedAccordions } = useMilestoneContext();
     const lastExpandedMilestoneRef = useRef<string | null>(null);

     useEffect(() => {
          if (!milestoneName || !combinedMilestoneData.length) {
               lastExpandedMilestoneRef.current = null;
               return;
          }

          const milestone = combinedMilestoneData.find(
               (mile: CombinedMilestone) =>
                    mile.milestoneName.toLowerCase() === milestoneName.toLowerCase()
          );

          if (milestone) {
               const isCurrentlyExpanded = expandedAccordions[milestone.milestoneName] || false;
               const isDifferentMilestone = lastExpandedMilestoneRef.current !== milestone.milestoneName;
               
               if (!isCurrentlyExpanded && isDifferentMilestone) {
                    toggleAccordion(milestone.milestoneName);
                    lastExpandedMilestoneRef.current = milestone.milestoneName;
               } else if (isCurrentlyExpanded && isDifferentMilestone) {
                    lastExpandedMilestoneRef.current = milestone.milestoneName;
               }
          }
     }, [milestoneName, combinedMilestoneData, toggleAccordion, expandedAccordions]);

     return (
          <Box sx={milestoneStyles.milestoneContainer}>
               <MilestoneHeaderSection />
               <MilestoneList />
          </Box>
     );
});

MilestoneComponentContent.displayName = "MilestoneComponentContent";